import React from 'react'
import Layout from '../components/layout'
import TabPage from '../components/TabPage/TabPageView';
import { StaticImage } from 'gatsby-plugin-image';





const TarievenIndex = (props) => {
  const tabPage1 = 
  <div style={{textAlign: 'left',textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
      <h3 >Pensionstalling</h3>
      <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/pensionprijs.png' />
      <h3>Algemeen</h3>
      <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/Algemeen_grid.png'/>
  </div>

const tabPage2 = 
<div style={{textAlign: 'left', textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
    <h3>Tarieven Pension</h3>
    <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/Pension_grid.png'/>
</div>

const tabPage3 = 
<div  style={{textAlign: 'left', textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
    <h3 >Lessen</h3>
    <StaticImage placeholder='none' backgroundColor='#2b2b2f'  alt='' src='../../static/Lessen_grid.png'/>

</div>

const tabPage4 = 
<div style={{textAlign: 'left', textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
    <h3 >Overig</h3>
    <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/Overig_grid.png'/>
</div>



    return (
      <Layout title={"Tarieven"} location={props.location}>
        <div className='empty_box'></div>
        <h1 style={{textAlign: 'center'}}>Tarieven</h1>

        <TabPage tabNames={["Algemeen", "Pension", "Lessen", "Overig"]} tabContent={[tabPage1, tabPage2, tabPage3, tabPage4,]}/>

        

        


      </Layout>

    )
  }


export default TarievenIndex





